<template>
  <v-app>
    <AppNavigation></AppNavigation>

    <v-content transition="slide-x-transition">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation';

export default {
  name: 'App',
  components: {
    AppNavigation
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || 'Upload';
    }
  }
};
</script>
<style>
body {
  font-family: 'Lato', sans-serif;
}
</style>
